import objectPath from 'object-path'
import { CONDITION_GROUP } from './Option'
import { getCurrentUi } from './Data'

export const getFormGroup = (designContext) => {
  const { jsonForm, isUiChanged } = designContext
  let formGroup = jsonForm?.formGroup || []
  let filterGroup = formGroup.filter((form) => {
    let { isWidget, widgetKey } = form
    if (isWidget) {
      let ui = getCurrentUi(widgetKey, jsonForm.schema, jsonForm.uischema)
      return ui?.key === widgetKey
    }
    return true
  })
  let tabFormGroup = objectPath.get(isUiChanged, 'tabFormGroup') || []
  return [...filterGroup, ...tabFormGroup]
}

export const getFormGroupOption = (designContext) => {
  const { jsonForm, isUiChanged } = designContext
  let formGroup = jsonForm?.formGroup || []
  let tabFormGroup = objectPath.get(isUiChanged, 'tabFormGroup') || []
  let allGroup = [...formGroup, ...tabFormGroup].map((form) => {
    let name = form.formComponentName || form.key
    return {
      layout: 'formGroup',
      key: form.key,
      name: name,
      fieldName: form.formDataName,
      shortName: form.formDataName,
      label: form.formDataName,
      value: name,
      isElement: false,
      groupType: 'formGroup',
      dynamicKey: '',
      groupIndex: CONDITION_GROUP.formGroup,
    }
  })
  return allGroup
}
